"use client";

import { ReactNode, useState } from "react";

import { Button } from "@/components/ui/button";

export const SeoLongSectionDescriptionClient = ({
  intro,
  content,
}: {
  intro: ReactNode;
  content: ReactNode;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={"mx-auto mt-28 mb-16 w-full border-t pt-12"}>
      <div className={"mx-auto max-w-[800px]"}>
        <div>
          {intro}
          {!open && (
            <div
              className={"flex justify-center pt-4"}
              onClick={() => {
                setOpen(true);
              }}
            >
              <Button variant={"outline"}>Zobacz więcej</Button>
            </div>
          )}

          <div className={open ? "block" : "hidden"}>{content}</div>
        </div>
      </div>
    </div>
  );
};
